/* eslint-disable react/prop-types */
import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import {
  RecaptchaProvider,
  CartContextProvider,
  CartActionButton,
  useCart,
} from '@bluefin/components';

import './EcommerceLayout.css';

function CartActionButtonLayout({ children, productUuid, locationUuid }) {
  const merchant = { productUuid, locationUuid };

  function isCheckoutPage() {
    if (typeof window === 'undefined') {
      return false;
    }
    const { pathname } = window.location;
    return pathname.endsWith('/checkout/');
  }

  const cart = useCart(merchant);

  return (
    <CartContextProvider value={{ cart }}>
      <CartActionButton className="fixed" show={!isCheckoutPage()} />
      {children}
    </CartContextProvider>
  );
}

function EcommerceLayout({ children }) {
  const data = useStaticQuery(graphql`
    query {
      fishermanBusinessProduct {
        uuid
      }
      fishermanBusiness {
        primaryLocation {
          uuid
        }
      }
    }
  `);

  const {
    fishermanBusinessProduct,
    fishermanBusiness: { primaryLocation },
  } = data;

  const { uuid: productUuid } = fishermanBusinessProduct;
  const { uuid: locationUuid } = primaryLocation;

  return (
    <div className="ecommerce-layout">
      <RecaptchaProvider>
        <CartActionButtonLayout productUuid={productUuid} locationUuid={locationUuid}>
          {children}
        </CartActionButtonLayout>
      </RecaptchaProvider>
    </div>
  );
}

export default EcommerceLayout;
